module.exports = __webpack_public_path__ + "img/device_fan.230aae14.png";